<template>
    <div id="setup-tab-nab-container">
        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.KeyExchangeURL')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'keyExchangeUrl'"
                    v-bind:MaxLengthProp="32"
                    v-model="editableItem.keyExchangeUrl"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_keyExchangeUrl'"
                    v-on:change="emitChanged"
                    v-bind:isValid="isFieldValid.keyExchangeUrl"
                    v-bind:invalidMessage="$t('Msg.InvalidField')"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.PayPageURL')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'paypageUrl'"
                    v-bind:MaxLengthProp="32"
                    v-model="editableItem.paypageUrl"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_paypageUrl'"
                    v-on:change="emitChanged"
                    v-bind:isValid="isFieldValid.paypageUrl"
                    v-bind:invalidMessage="$t('Msg.InvalidField')"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.CustNBR')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'api_custNbr'"
                    v-model.number="editableItem.custNbr"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_custNbr'"
                    v-on:change="emitChanged"
                    v-bind:isValid="isFieldValid.custNbr"
                    v-bind:invalidMessage="$t('Msg.InvalidField')"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.MerchNBR')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'api_merchNbr'"
                    v-model.number="editableItem.merchNbr"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_merchNbr'"
                    v-on:change="emitChanged"
                    v-bind:isValid="isFieldValid.merchNbr"
                    v-bind:invalidMessage="$t('Msg.InvalidField')"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.DBANBR')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'api_dbaNbr'"
                    v-model.number="editableItem.dbaNbr"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_dbaNbr'"
                    v-on:change="emitChanged"
                    v-bind:isValid="isFieldValid.dbaNbr"
                    v-bind:invalidMessage="$t('Msg.InvalidField')"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.TerminalNBR')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'api_terminalNbr'"
                    v-model.number="editableItem.terminalNbr"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_terminalNbr'"
                    v-on:change="emitChanged"
                    v-bind:isValid="isFieldValid.terminalNbr"
                    v-bind:invalidMessage="$t('Msg.InvalidField')"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.Mac')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'api_MAC'"
                    v-bind:MaxLengthProp="36"
                    v-model="editableItem.mac"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_MAC'"
                    v-on:change="emitChanged"
                    v-bind:isValid="isFieldValid.mac"
                    v-bind:invalidMessage="$t('Msg.InvalidField')"
                >
                </MdEdit>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Utils from '@/common/utils';

export default {
    name: 'TabSetupNab',
    props: {
        value: {
            Type: Object,
            default: null
        },
        isReadOnly: {
            Type: Boolean,
            default: false
        }
    },
    data() {
        const defaultItemData = {
            keyExchangeUrl: '',
            paypageUrl: '',
            custNbr: null,
            merchNbr: null,
            dbaNbr: null,
            terminalNbr: null,
            mac: ''
        };
        return {
            editableItem: this.value || defaultItemData,
            defaultItemData: defaultItemData,
            isFieldValid: {
                keyExchangeUrl: true,
                paypageUrl: true,
                custNbr: true,
                merchNbr: true,
                dbaNbr: true,
                terminalNbr: true,
                mac: true
            }
        };
    },
    watch: {
        value(newVal) {
            this.editableItem = newVal || this.defaultItemData;
        }
    },
    methods: {
        emitChanged() {
            this.$emit('input', this.editableItem);
        },

        validate_required() {
            if (
                Utils.isNullOrEmptyString(this.editableItem.keyExchangeUrl) &&
                Utils.isNullOrEmptyString(this.editableItem.paypageUrl) &&
                Utils.isNullOrEmptyString(this.editableItem.custNbr) &&
                Utils.isNullOrEmptyString(this.editableItem.merchNbr) &&
                Utils.isNullOrEmptyString(this.editableItem.dbaNbr) &&
                Utils.isNullOrEmptyString(this.editableItem.terminalNbr) &&
                Utils.isNullOrEmptyString(this.editableItem.mac)
            ) {
                return true;
            }

            this.isFieldValid.keyExchangeUrl = !Utils.isNullOrEmptyString(
                this.editableItem.keyExchangeUrl
            );
            this.isFieldValid.paypageUrl = !Utils.isNullOrEmptyString(this.editableItem.paypageUrl);
            this.isFieldValid.custNbr = this.editableItem.custNbr !== null;
            this.isFieldValid.merchNbr = this.editableItem.merchNbr !== null;
            this.isFieldValid.dbaNbr = this.editableItem.dbaNbr !== null;
            this.isFieldValid.terminalNbr = this.editableItem.terminalNbr !== null;
            this.isFieldValid.mac = !Utils.isNullOrEmptyString(this.editableItem.mac);

            return (
                this.isFieldValid.keyExchangeUrl &&
                this.isFieldValid.paypageUrl &&
                this.isFieldValid.custNbr &&
                this.isFieldValid.merchNbr &&
                this.isFieldValid.dbaNbr &&
                this.isFieldValid.terminalNbr &&
                this.isFieldValid.mac
            );
        }
    }
};
</script>
